import { z } from "zod";

export const textTemplateSchema = z
  .array(
    z.union([
      z.object({ text: z.string().max(1000000) }).strict(),
      z.object({ fieldId: z.string().min(1) }).strict(),
    ]),
  )
  .min(1)
  .max(512)
  .superRefine((parts, ctx) => {
    if (
      parts.reduce(
        (total, part) => total + ("text" in part ? part.text.length : 0),
        0,
      ) > 1000000
    )
      ctx.addIssue({
        code: "custom",
        message: "Text template exceeds 1,000,000 characters",
      });
  });
export type TextTemplate = z.infer<typeof textTemplateSchema>;
const escape = (value: string) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

/** Authored literals may contain rich markup; field values are always text. */
export function renderTextTemplate(
  parts: TextTemplate,
  value: (fieldId: string) => string,
  rich = false,
): string {
  let length = 0;
  return parts
    .map((part) => {
      const text =
        "text" in part
          ? part.text
          : rich
            ? escape(value(part.fieldId)).replace(
                /\r\n?|\n|\u2028|\u2029/g,
                "<br>",
              )
            : value(part.fieldId);
      length += text.length;
      if (length > 1000000)
        throw new Error("Rendered text template exceeds 1,000,000 characters");
      return text;
    })
    .join("");
}
